/** Приводит значение к виду #RRGGBB для p-colorPicker и style.background-color. */
export function toCssHexColor(value: string | null | undefined): string | null {
  if (value == null) {
    return null;
  }
  const s = String(value).trim();
  if (!s) {
    return null;
  }
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) {
    return s;
  }
  if (/^[0-9A-Fa-f]{6}$/.test(s)) {
    return `#${s}`;
  }
  return s;
}

/**
 * Generates a consistent color from a string using hash-based algorithm.
 * The same string will always produce the same color.
 * @param input - The string to generate color from (e.g., question.Title)
 * @returns Hex color string in format #RRGGBB
 */
export function generateColorFromStringHash(input: string): string {
  if (!input) {
    return '#4A90E2'; // Default blue color
  }

  // Generate a simple hash from the string
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Use hash to determine hue (0-360)
  const hue = Math.abs(hash % 360);
  
  // Use fixed saturation and lightness for vibrant, readable colors
  const saturation = 70; // 70% saturation for vibrant colors
  const lightness = 50;  // 50% lightness for good contrast

  // Convert HSL to hex
  return hslToHex(hue, saturation, lightness);
}

/**
 * Converts HSL color values to hex string.
 * @param h - Hue (0-360)
 * @param s - Saturation (0-100)
 * @param l - Lightness (0-100)
 * @returns Hex color string in format #RRGGBB
 */
function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r = 0, g = 0, b = 0;

  if (0 <= h && h < 60) {
    r = c; g = x; b = 0;
  } else if (60 <= h && h < 120) {
    r = x; g = c; b = 0;
  } else if (120 <= h && h < 180) {
    r = 0; g = c; b = x;
  } else if (180 <= h && h < 240) {
    r = 0; g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; g = 0; b = c;
  } else if (300 <= h && h < 360) {
    r = c; g = 0; b = x;
  }

  const toHex = (n: number) => {
    const hex = Math.round((n + m) * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/** Лёгкая заливка для чипа (alfa 0–1). */
export function hexToRgba(hex: string, alpha: number): string {
  const h = toCssHexColor(hex);
  if (!h || h.length < 7) {
    return `rgba(154, 164, 184, ${alpha})`;
  }
  const r = parseInt(h.slice(1, 3), 16);
  const g = parseInt(h.slice(3, 5), 16);
  const b = parseInt(h.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
